import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import Loader from "src/components/Loader";
import { isEmpty } from "src/utils/helpers";
import { showAccessModal, showModal } from "src/actions/modal.actions";

import { getCloudWatch } from "src/selectors";
import CamvioTable2, { CamvioTable2Context, DefaultDashboardSearch, LoadMore } from "src/components/UI/CamvioTable2";
import { getCloudWatchLogs, getCloudWatchStream } from "src/actions/cloudWatchLogs.actions";

/**
 * Actual content of the Notification Queue management page
 */
class SystemLogsList extends Component {
  state = {
    isLoading: false, // loading data?
    pageSize: 20,
    itemsList: [],
    itemsTotal: 0,
    loadingSearch: false,
    noMoreResults: true,
    isDownloading: false,
    nextPage: false,
    logStream: "",
    limit: 20,
    fromDateFilter: Date.now() - 24 * 60 * 60 * 1000,
    toDateFilter: 0,
    selectedOption: "",
    searchTerm: "",
    expandedRow: false,
    filters: [Date.now() - 24 * 60 * 60 * 1000]
  };

  componentDidMount() {
    this.props.getCloudWatchStream().then((response) => {
    }).catch((error) => {
      console.error("Error fetching CloudWatch Stream:", error);
    });
  }


  clearAndReloadList = (data) => {
    this.setState(
      {
        itemsList: [],
        loadingSearch: true,
        expandedRow: false

      },
      () => this.reloadList(true, data)
    );
  };

  reloadList = (clearList, data) => {
    const filteredData = Object.fromEntries(
      Object.entries({
        endTime: this.state.toDateFilter,
        keyword: this.state.searchTerm,
        logStreamName: this.state.logStream,
        startTime: this.state.fromDateFilter,
        limit: this.state.limit
      }).filter(([_, value]) => value !== 0 && value !== "" && value !== null)
    );

    const payload = {
      ...filteredData
    };

    this.setState(
      {
        isLoading: true,
        loadingSearch: true,
        itemsList: clearList ? [] : this.state.itemsList
      },
      () => {
        this.props.getCloudWatchLogs(payload)
          .then((response) => {
            this.setState({
              isLoading: false,
              loadingSearch: false,
              itemsList: response
            }, () => this.checkResultsLength());
          })

          .catch((error) => {
            console.error("Error loading logs:", error);
            this.setState({ isLoading: false, loadingSearch: false });
          });
      }
    );
  };

  loadMore = () => {

    this.setState({ limit: +this.state.limit + +this.state.pageSize }, () => {
      this.reloadList(false);
    });
  };

  checkResultsLength = () => {
    if (this.state.itemsList.hasNextPage) {
      this.setState({
        noMoreResults: false
      });
    } else {
      this.setState({
        noMoreResults: true
      });
    }
  };

  handlePageSizeChange = (value) => {
    this.setState({
      pageSize: value
    });
  };

  debounceHandleInputChange = (event) => {
    this.setState({
      searchTerm: event.target.value
    });
  };


  onDashboardAction = (action, data) => {
    this.setState({ logStream: data });
    switch (action) {
      case "SEARCH":
        this.clearAndReloadList(data);
        break;
      case "DOWNLOAD":
        // TODO;
        break;
      case "XLS":
        this.downloadTable("XLS");
        break;
      case "CSV":
        this.downloadTable("CSV");
        break;
      default:
        break;
    }
  };


  render() {
    const { pageSize, itemsList, isLoading, isDownloading } = this.state;
    return (
      <Fragment>
        <CamvioTable2Context.Provider value={this.state}>
          <div className="tab-pane camvio-table-search" style={{ borderRadius: "0.5rem" }}>
            <DefaultDashboardSearch
              onAction={this.onDashboardAction}
              onInputChange={this.debounceHandleInputChange}
              disabled={isLoading || this.state.loadingSearch || isDownloading}
              inputPlaceholder="Match terms, phrases, or values in your log events..."
              showDownloadButton={false}
              showSelectDropdown={true}
              filters={this.state.filters}
              dropDownData={this.props.logStreams}

              actionButtons={{
                secondary: []
              }}
            >
              <div className="d-flex" style={{ alignItems: "center" }}>
                <div className="form-group col">
                  <label className="dropdown-header" htmlFor="fromCloudWatchLogsFilter">Start Date & Time</label>
                  <div
                    className="input-group input-group-sm date"
                    id="datetimepicker-notif-filter-1"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input"
                      selected={this.state.fromDateFilter ? new Date(this.state.fromDateFilter) : null}
                      onChange={(value) => this.setState({
                        fromDateFilter: value ? value.getTime() : null, filters: value
                          ? [...this.state.filters, value.getTime()]
                          : this.state.filters.filter((filter) => filter !== this.state.fromDateFilter)
                      })}
                      placeholderText="MM/DD/YYYY"
                      name="fromCloudWatchLogsFilter"
                      popperPlacement="top-end"
                      isClearable={true}
                      showTimeSelect
                      timeFormat="hh:mm aa"
                      timeIntervals={15}
                      dateFormat="MM/dd/yyyy hh:mm aa"
                      popperModifiers={{
                        offset: {
                          enabled: true,
                          offset: "5px, 10px"
                        },
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                          boundariesElement: "viewport"
                        }
                      }}
                    />
                  </div>
                </div>


                {/*<h6 className="dropdown-header">To</h6>*/}


                <div className="form-group col">
                  <label className="dropdown-header" htmlFor="fromCloudWatchLogsFilter">End Date & Time</label>
                  <div
                    className="input-group input-group-sm date"
                    id="datetimepicker-notif-filter-2"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input"
                      selected={this.state.toDateFilter ? new Date(this.state.toDateFilter) : null}
                      onChange={(value) => this.setState({
                        toDateFilter: value ? value.getTime() : null, filters: value
                          ? [...this.state.filters, value.getTime()]
                          : this.state.filters.filter((filter) => filter !== this.state.toDateFilter)
                      })}
                      placeholderText="MM/DD/YYYY"
                      name="toCloudWatchLogsFilter"
                      popperPlacement="top-end"
                      isClearable={true}
                      showTimeSelect
                      timeFormat="hh:mm aa"
                      timeIntervals={15}
                      dateFormat="MM/dd/yyyy hh:mm aa"
                      popperModifiers={{
                        offset: {
                          enabled: true,
                          offset: "5px, 10px"
                        },
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                          boundariesElement: "viewport"
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </DefaultDashboardSearch>
            {isDownloading && <Loader />}

            {!this.state.loadingSearch && isEmpty(itemsList.events) && (
              <div className="container">
                <p>No data found</p>
              </div>
            )}
            {!isEmpty(itemsList.events) && !isDownloading && (
              <CamvioTable2
                headerDefs={[
                  { name: "TimeStamp", field: "timestamp", sortable: false },
                  { name: "Message", field: "message", sortable: false },
                  { name: "", field: "", sortable: false }
                ]}
                style={true}
              >
                <tbody>
                {this.state.itemsList.events.map((item, index) => (
                  <Fragment key={`cw_item_${item.eventId}`}>
                    <tr>
                      <td>
                        {item.timestamp && (
                          <span title="Created at" style={{ whiteSpace: "nowrap" }}>
                            {moment(item.timestamp).format("MM/DD/YYYY hh:mm:ss A")}
                          </span>
                        )}
                      </td>
                      <td>
                        <div
                          className="flex"
                          style={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            width: "100%",
                            maxHeight: "100px",
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical"
                          }}
                        >
                          <span>{item.message || "N/A"}</span>
                        </div>
                      </td>
                      <td>
                        <div>

                          <button
                            className="btn btn-circle btn-order-collapse-toggle text-muted"
                            type="button"
                            style={{ borderColor: "#adb5bd", borderStyle: "solid" }}
                            title="Expand / Collapse"
                            onClick={() =>
                              this.setState((prevState) => ({
                                expandedRow: prevState.expandedRow === index ? null : index
                              }))
                            }
                          >
                            <i
                              className={`fas ${
                                this.state.expandedRow === index ? "fa-angle-double-up" : "fa-angle-double-down"
                              }`}
                            ></i>
                          </button>

                        </div>
                      </td>
                    </tr>
                    {this.state.expandedRow === index && (
                      <tr>
                        <td colSpan="3">
                          <div
                            style={{ padding: "10px", position: "relative" }}
                            className="cmv-container-cloudwatch cmv-container-cloudwatch-log-viewer"
                          >
                            <button
                              onClick={() =>
                                navigator.clipboard.writeText(
                                  `${moment(item.timestamp).format("MM/DD/YYYY hh:mm:ss A")} ${item.message}`
                                )
                              }
                              className="text-muted"
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                cursor: "pointer",
                                fontSize: "1rem",
                                padding: "0.25rem 0.5rem",
                                borderRadius: "5px",
                                border: "none",
                                color: "#fff",
                                backgroundColor: "rgba(255, 255, 255, 0.3)",
                              }}
                              title="Copy message and timestamp to clipboard"
                            >
                              <i className="fas fa-clipboard text-white"></i>
                            </button>

                            <p
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                width: "100%",
                                overflow: "hidden"
                              }}
                            >
                              {item.timestamp && (
                                <span title="Created at">
                                {moment(item.timestamp).format("MM/DD/YYYY hh:mm:ss A")} {" "}
                              </span>
                              )}
                              {item.message}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}
                </tbody>
              </CamvioTable2>

            )}
          </div>
          {(isLoading || this.state.loadingSearch) && <Loader />}
          {!this.state.noMoreResults && (
            <LoadMore
              disabled={this.state.loadingSearch || this.state.noMoreResults || isDownloading}
              pageSize={pageSize}
              onPageSizeChange={(pageSize) => {
                this.handlePageSizeChange(pageSize);
              }}
              onLoadMore={() => this.loadMore()}
            />
          )}
        </CamvioTable2Context.Provider>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const logStreams = getCloudWatch(state).streams;

  // Add new actions to the IF statement in render(), enabling the "ACTIONS" table column for users with rights
  return {
    logStreams
  };
};

const mapDispatchToProps = {
  showModal,
  showAccessModal,
  getCloudWatchStream,
  getCloudWatchLogs
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemLogsList);
